import { render, staticRenderFns } from "./UserAdminDashboard.vue?vue&type=template&id=49dc126f&scoped=true&"
import script from "./UserAdminDashboard.vue?vue&type=script&lang=ts&"
export * from "./UserAdminDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./UserAdminDashboard.vue?vue&type=style&index=0&id=49dc126f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dc126f",
  null
  
)

export default component.exports